(ns ui.view.card.fees.model
  (:require [clojure.string :as string]
            [common.util :as cu]))

(defn delete-fee-confirmation-modal-id
  [{:keys [card-state-path] :as _ctx}]
  (str
   (->> card-state-path
        (mapv (fn [part]
                (if (keyword? part)
                  (cu/kw->str part)
                  part)))
        (string/join "-"))
   "-delete-fee-confirmation-modal"))
